module.exports = __webpack_public_path__ + "img/wx.191951fc.png";